module.exports = __webpack_public_path__ + "img/step6.ce80132f.jpg";